import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';

import staticSrc from '../../../common/public';
import titleMetaDescription from '../../utils/SEO/titleMetaDescription.json';
import { IS_PROD, GTM_ID, GTM_ID_DEV } from '../../../constants';

const BaseElements = (props) => {
  const {
    location: { pathname },
    deviceType,
  } = props;

  const mapMetaData = titleMetaDescription[pathname] || titleMetaDescription['/'];
  const title = mapMetaData.title;
  const description = mapMetaData.description;

  if (pathname.includes('/amp/')) return null;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="author" content="LINE TV - 精彩隨看"></meta>
      <meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1,user-scalable=no" />
      {/* <meta name="apple-itunes-app" content="app-id=1005557642" /> */}
      {/* <meta name="google-play-app" content="app-id=com.chocolabs.app.chocotv" /> */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="google-site-verification" content="C11lIzxpx0vEf7zInYfk8rR8LPG4FkZF5LiVWVTTjJ0" />
      <meta name="description" property="og:description" content={description} />
      <meta property="og:url" content={`https://www.linetv.tw${pathname}`} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="LINE TV" />
      <meta property="og:locale" content="zh_TW" />
      <meta property="fb:app_id" content="332002637008755" />
      <meta name="robots" content="noindex" />

      <link rel="preconnect" href="https://static.linetv.tw" />

      <link rel="canonical" href={`https://www.linetv.tw${pathname}`} />
      <link rel="shortcut icon" href="https://img.linetv.tw/WEB/linetv_favicon.ico" type="image/vnd.microsoft.icon" />
      <link rel="android-touch-icon" href={`${staticSrc}/images/LINETV.png`} />
      <link rel="apple-touch-icon" href={`${staticSrc}/images/LINETV.png`} />

      <script type="application/ld+json">{
        JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Corporation",
          "name": "CHOCO Media Entertainment",
          "legalName": "巧克科技新媒體股份有限公司",
          "description": "巧克科技新媒體 (CHOCO Media Entertainment)為台灣新創團隊，於2018年11月獲LINE Corp.投資，與LINE TV整併，成為廣受用戶喜愛和歡迎的行動影音串流平台。",
          "url": "https://www.linetv.tw",
          // "logo": ["https://img.linetv.tw/logo/CME_logo.jpg","https://img.linetv.tw/logo/CME_black.png"],
          // "image": ["https://img.linetv.tw/logo/CME_logo.jpg","https://img.linetv.tw/logo/CME_black.png"],
          "foundingDate": "2011",
          "founders": [
            { "@type": "Person", "name": "劉于遜" },
            { "@type": "Person", "name": "翁瑞廷" },
            { "@type": "Person", "name": "黃崇傑" },
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "民權東路三段142號17樓",
            "addressLocality": "松山區",
            "addressRegion": "台北市Taipei",
            "postalCode": "10542",
            "addressCountry": "台灣Taiwan",
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "email": "service@linetv.tw",
            "url": ['https://help.linetv.tw/', 'https://www.linetv.tw'],
          },
          "sameAs": [
            "https://www.facebook.com/LINETV.taiwan/",
            "https://www.instagram.com/linetv.tw/",
            "https://www.youtube.com/channel/UCouTB9QM76no5cUdqmFZCOQ",
            "https://play.google.com/store/apps/details?id=com.chocolabs.app.chocotv",
            "https://apps.apple.com/tw/app/line-tv-%E7%B2%BE%E5%BD%A9%E9%9A%A8%E7%9C%8B/id1005557642?l=en",
            "https://zh.wikipedia.org/wiki/LINE_TV",
            "https://www.wikidata.org/wiki/Q28412981",
            "https://www.crunchbase.com/organization/line-corporation",
            "https://www.crunchbase.com/organization/chocolabs-ohcool",
            "https://tv.line.me/",
            "https://help.linetv.tw/",
          ],
        })
      }</script>

      <script type="application/ld+json">{
        JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "url": "https://www.linetv.tw",
          "name": "LINE TV",
          "description": "LINE TV提供熱門戲劇、綜藝、動漫、電影、BL劇等優質內容，並持續投資原創內容製作，自製劇《HIStory》更於2018年入圍金鐘獎迷你劇集，現為國內原創內容產量最大的OTT業者。",
          "producer": {
            "@type": "Corporation",
            "name": "CHOCO Media Entertainment",
          },
          "publisher": {
            "@type": "Corporation",
            "name": "CHOCO Media Entertainment",
          },
          "keywords": ["追劇","線上看","免費","高畫質","HD","高清","韓劇","台劇","陸劇","BL","動漫","HIStory","TV","LINE","CHOCO","電視劇","OTT","正版","影音","愛奇藝","LiTV","Netflix","KKTV","Drama","花絮"],
          "isAccessibleForFree": true,
        })
      }</script>

      {/* TODO: onead tracking code */}
      {/* <script async src="https://pixel.onead.com.tw/static/js/onead-pixel.min.js" /> */}
      {/* <script>{'window.onead_pixel = window.onead_pixel || [];'}</script> */}

      {/* {
        !(/^\/(login|player|community)/i.test(pathname)) &&
        <script>{`
          (function(i,s,o,g,r,a,m){i['EmaticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//api.ematicsolutions.com/v1/ematic.min.js','ematics');var ematicApikey="b4786c0f907d11e8b2ba0242ac110002-sg3";var opt={email:localStorage.getItem("email")||"",country_iso:"TW",currency_iso:"TWD",language_iso:"en"};ematics("create",ematicApikey,opt);
        `}</script>
      } */}

      {/* Google Analytics */}
      <script>{`window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;`}</script>
      <script async src="https://www.google-analytics.com/analytics.js"></script>
      {/* End Google Analytics */}

      {/* Google Tag Manager */}
      <script>{`
        window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event:'gtm.js'
        });
      `}</script>
      <script async src={`https://www.googletagmanager.com/gtm.js?id=${IS_PROD ? GTM_ID : GTM_ID_DEV}`}></script>
      {/* End Google Tag Manager */}

      <body
        className={cx({
          'is-desktop': deviceType.isDesktop,
          'is-mobile': deviceType.isMobile,
          'is-tablet': deviceType.isTablet,
        })}
      />
    </Helmet>
  );
};

function maStateToProps({ deviceType }) {
  return {
    deviceType,
  };
}

export default withRouter(connect(maStateToProps)(BaseElements));
